export default __webpack_public_path__ + "static/media/2-pieces-upper-mantle.a8fc8893.svg";